import React, { useState, useEffect } from "react";
import "./investorKYC.css";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import { DatePicker, Divider, Select, message } from "antd";
import { uploadProfileDocumentToAWS } from "../../Helper/uploadDocument";
import AxiosInstance from "../../../AxiosInstance";
import { Option } from "antd/es/mentions";
import chooseInvestor from "../../../assets/become_investor.png";

import {
  banksListController,
  countriesListController,
  statesListController,
} from "../../Helper/provider";
import OtherPageHeader from "../../../components/OtherHeader";
import {
  get18YearBackDate,
  getBankAccountType,
  getEducationType,
} from "../../../utils";
import VerifyPanModal from "../../../components/Model/VerifyPanModal";
import VerifyAadharModal from "../../../components/Model/verifyAadhaarModal";
import moment from "moment";
import dayjs from "dayjs";
import {
  genderOptions,
  isPoliticallyExposedOptions,
  isSmokerOptions,
  maritialStatusOptions,
  occupationOptions,
  relationshipOptions,
} from "../../../utils/dropDownOptions";
import { AllowedProfileEditStatus, maxFileSize } from "../../../constants";
import {
  documentAccpetedTypes,
  documentWidget,
  iDocumentStages,
} from "../../../utils/constants";
import RegisterAsCompany from "./RegisterAsCompany";

export default function InvestorKYC() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });
  const [countries, setCountries] = useState([]);
  const [panDoc, setpanDoc] = useState();
  const [aadharDoc, setaadharDoc] = useState();
  const [cancelledChecqDoc, setcancelledChecqDoc] = useState();
  const [ITRDoc, setITRDoc] = useState();
  const [bankStatementDoc, setBankStatementDoc] = useState();
  const [photoDoc, setPhotoDoc] = useState();
  const [passportDoc, setPasportDoc] = useState();
  const [stateList, setStateList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nomineeDetails, setNomineeDetails] = useState([]);
  const [verifyPanModalState, setVerifyPanModalState] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [verifyAadhaarModalState, setVerifyAadhaarModalState] = useState(false);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);

  const [profileData, setProfileData] = useState({});
  const [isCompany, setIsCompany] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 750px)" });

  const [documentHill, setDocumentHill] = useState({
    panDoc: { status: iDocumentStages.NOT_PICKED, url: "", key: "panDoc" },
    aadharDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "aadharDoc",
    },
    cancelledChecqDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "cancelledChecqDoc",
    },
    ITRDoc: { status: iDocumentStages.NOT_PICKED, url: "", key: "ITRDoc" },
    bankStatementDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "bankStatementDoc",
    },
    photoDoc: { status: iDocumentStages.NOT_PICKED, url: "", key: "photoDoc" },
    passportDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "passportDoc",
    },
  });
  useEffect(() => {
    console.log("use Effect", documentHill);
  }, [documentHill]);

  useEffect(() => {
    getProfileDataNew();
    getSpinnerData();
  }, []);
  const getSpinnerData = async () => {
    const ctn = await countriesListController();
    setCountries(ctn);
    const bnk = await banksListController();
    setBankList(bnk);
  };
  const getProfileDataNew = async () => {
    let profileData = {};
    const result = await AxiosInstance()
      .get(`/user/me`)
      .catch((error) => {});
    profileData = result.data;
    console.log("setup of users", result.data);
    setProfileData(result.data);
    console.log(profileData);

    if (profileData) {
      console.log(profileData?.nominees[0]?.dob);
      if (profileData.userType === "ENTITY") {
        setIsCompany(true);
        return;
      }
      console.log(profileData.nominees.length);
      if (profileData.isPanVerified && profileData.pan) {
        // pan field will be disable only if pan number is also available
        setValue("pan", profileData.pan);
        setIsPanVerified(true);
        console.log("pan verified");
      }
      if (profileData.pan) {
        setValue("pan", profileData.pan);
      }
      if (profileData.isAadhaarVerified && profileData.aadhar) {
        // aadhaar field will be disable only if pan number is also available
        setIsAadhaarVerified(true);
      }
      if (profileData.aadhar) {
        setValue("aadhar", profileData.aadhar);
      }
      if (profileData.gender) setValue("gender", profileData.gender);
      if (profileData.address) setValue("address", profileData.address);
      if (profileData.occupation)
        setValue("occupation", profileData.occupation);
      if (profileData.city) setValue("city", profileData.city);
      if (profileData.countryId) {
        countryChange(profileData.countryId);
      }
      if (profileData.stateId) {
        stateChange(profileData.stateId);
      }
      if (profileData.pinCode) setValue("pinCode", profileData.pinCode);
      if (profileData.bankAccountNumber)
        setValue("bankAccountNumber", profileData.bankAccountNumber);
      if (profileData.bankId) {
        bankNameChange(profileData.bankId);
      }
      if (profileData.accountType) {
        accountTypeChange(profileData.accountType);
      }
      if (profileData.IFSCCode) setValue("IFSCCode", profileData.IFSCCode);
      if (profileData.UPICode) setValue("UPICode", profileData.UPICode);
      if (profileData.EIANumber) setValue("EIANumber", profileData.EIANumber);
      if (profileData.nomineeName)
        setValue("nomineeName", profileData.nomineeName);
      if (profileData.maritalStatus)
        setValue("maritalStatus", profileData.maritalStatus);
      if (profileData.annualIncome)
        setValue("annualIncome", parseInt(profileData.annualIncome));
      if (profileData.education) setValue("education", profileData.education);
      if (profileData.natureOfDuties)
        setValue("natureOfDuties", profileData.natureOfDuties);
      if (profileData.sourceOfFund)
        setValue("sourceOfFund", profileData.sourceOfFund);

      setValue("isPoliticallyExposed", profileData?.isPoliticallyExposed);
      if (profileData.relativeName)
        setValue("relativeName", profileData.relativeName);

      // setValue("isSmoker", profileData?.isSmoker);
      if (profileData.bankBranchName)
        setValue("bankBranchName", profileData.bankBranchName);

      if (profileData.nationality)
        setValue("nationality", profileData.nationality);

      if (profileData.nameOfOrganization)
        setValue("nameOfOrganization", profileData.nameOfOrganization);

      if (profileData.jobTitle) setValue("jobTitle", profileData.jobTitle);
      if (profileData.industryType)
        setValue("industryType", profileData.industryType);
      if (profileData.nominees && profileData.nominees[0]) {
        setValue("nomineeContact", profileData.nominees[0]?.contactNo);
        setValue("nomineeEmail", profileData.nominees[0]?.email);
        setValue("nomineeName", profileData.nominees[0]?.name);
        setValue("nomineeRelationship", profileData.nominees[0]?.relationship);

        setValue(
          "nomineeDob",
          dayjs(profileData.nominees[0]?.dob, "YYYY/MM/DD")
        );
        const newData = {
          ...profileData,
          nomineeDob: profileData.nominees[0]?.dob,
        };
        setProfileData(newData);
        console.log(profileData.nomineeDob);
      }
    }
  };

  const navigate = useNavigate();
  const onSubmit = async (value) => {
    // if (loading) return;
    // setLoading(true);
    console.log("Values...", value);
    if (documentHill.panDoc.status === iDocumentStages.UPLOADED)
      value.PANDocument = documentHill.panDoc.url;
    if (documentHill.aadharDoc.status === iDocumentStages.UPLOADED)
      value.AADHARDocument = documentHill.aadharDoc.url;
    if (documentHill.cancelledChecqDoc.status === iDocumentStages.UPLOADED)
      value.cancelledCheck = documentHill.cancelledChecqDoc.url;

    if (documentHill.photoDoc.status === iDocumentStages.UPLOADED)
      value.photo = documentHill.photoDoc.url;

    if (documentHill.passportDoc.status === iDocumentStages.UPLOADED)
      value.passportDocument = documentHill.passportDoc.url;

    if (documentHill.bankStatementDoc.status === iDocumentStages.UPLOADED)
      value.bankStatement = documentHill.bankStatementDoc.url;
    if (documentHill.ITRDoc.status === iDocumentStages.UPLOADED)
      value.ITRCopy = documentHill.ITRDoc.url;
    value.nominees = [
      {
        contactNo: value.nomineeContact,
        email: value.nomineeEmail,
        name: value.nomineeName,
        dob: value.nomineeDob,
        relationship: value.nomineeRelationship,
      },
    ];
    delete value.nomineeContact;
    delete value.nomineeEmail;
    delete value.nomineeName;
    delete value.nomineeDob;
    delete value.nomineeRelationship;
    value.annualIncome = parseInt(value.annualIncome);
    console.log(value);
    AxiosInstance()
      .put("/profile", value)
      .then(() => {
        setLoading(false);
        window.location.href = "/investorDashboard";
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.response.data.message);
      });
  };
  const genderChange = (data) => {
    errors.gender = false;
    setValue("gender", data);
  };
  const isPoliticallyExposedChange = (data) => {
    errors.isPoliticallyExposed = false;
    setValue("isPoliticallyExposed", data);
  };
  const isSmokerChange = (data) => {
    errors.isSmoker = false;
    setValue("isSmoker", data);
  };

  const relationshipChange = (data) => {
    errors.nomineeRelationship = false;
    setValue("nomineeRelationship", data);
  };

  const countryChange = async (value) => {
    errors.countryId = false;
    setValue("countryId", parseInt(value));
    const list = await statesListController(value);
    setStateList(list);
  };
  const nationalityChange = async (value) => {
    errors.nationality = false;
    setValue("nationality", value);
  };

  const stateChange = (value) => {
    errors.stateId = false;
    setValue("stateId", parseInt(value));
  };
  const bankNameChange = (value) => {
    setValue("bankId", parseInt(value));
  };
  const occupationChange = (value) => {
    setValue("occupation", value);
  };
  const maritalStatusChange = (value) => {
    setValue("maritalStatus", value);
  };
  const accountTypeChange = (value) => {
    setValue("accountType", value);
  };
  const educationChange = (value) => {
    setValue("education", value);
  };

  async function uploadHandler(key, userId, event) {
    setDocumentHill((prev) => ({
      ...prev,
      [key]: { ...prev[key], status: iDocumentStages.PICKED },
    }));
    console.log(documentHill);
    //upload document
    const result = await uploadProfileDocumentToAWS(
      event.target.files[0],
      userId
    );
    console.log("result", result);
    //if result then set the api result
    if (result !== null && result !== "undefined") {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          status: iDocumentStages.UPLOADED,
          url: result,
        },
      }));
    } else {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: { ...prev[key], status: iDocumentStages.UPLOAD_FAILED },
      }));
    }
  }

  async function handleDocumentNew(event, target) {
    if (event.target.files[0].size > maxFileSize) {
      alert("Maximum File size: 5MB");
      return;
    }
    const userId = localStorage.getItem("userId");
    switch (target) {
      case documentHill.panDoc.key:
        // set document for retry function
        setpanDoc(event);
        uploadHandler("panDoc", userId, event);

        break;
      case documentHill.aadharDoc.key:
        setaadharDoc(event);
        uploadHandler("aadharDoc", userId, event);

        break;

      case documentHill.cancelledChecqDoc.key:
        setcancelledChecqDoc(event);
        uploadHandler("cancelledChecqDoc", userId, event);

        break;

      case documentHill.ITRDoc.key:
        setITRDoc(event);
        uploadHandler("ITRDoc", userId, event);
        break;

      case documentHill.bankStatementDoc.key:
        setBankStatementDoc(event);
        uploadHandler("bankStatementDoc", userId, event);
        break;
      case documentHill.photoDoc.key:
        setPhotoDoc(event);
        uploadHandler("photoDoc", userId, event);
        break;

      case documentHill.passportDoc.key:
        setPasportDoc(event);
        uploadHandler("passportDoc", userId, event);
        break;

      default:
        break;
    }
  }

  function iretryFunction(document) {
    if (documentHill.panDoc.key === document.key)
      handleDocumentNew(panDoc, documentHill.panDoc.key);
    else if (documentHill.aadharDoc.key === document.key)
      handleDocumentNew(aadharDoc, document.key);
    else if (documentHill.cancelledChecqDoc.key === document.key)
      handleDocumentNew(cancelledChecqDoc, document.key);
    else if (documentHill.ITRDoc.key === document.key)
      handleDocumentNew(ITRDoc, document.key);
    else if (documentHill.bankStatementDoc.key === document.key)
      handleDocumentNew(bankStatementDoc, document.key);
    else if (documentHill.bankStatementDoc.key === document.key)
      handleDocumentNew(bankStatementDoc, document.key);
    else if (documentHill.photoDoc.key === document.key)
      handleDocumentNew(photoDoc, document.key);
    else if (documentHill.passportDoc.key === document.key)
      handleDocumentNew(passportDoc, document.key);
  }

  const onNomineeUpdate = (e) => {
    const nomineePayload = nomineeDetails;
    nomineePayload[0] = {
      ...nomineePayload[0],
      [e.target.name]: e.target.value,
    };
    setNomineeDetails(nomineePayload);
  };

  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <div className="leftDivInvestorKYC">
        <div className="common-width-inv">
          <div className="d-flex justify-content-between">
            <button
              type="submit"
              title="back-button"
              className="back-button mt-3 mb-4"
              onClick={() => navigate(-1)}
            >
              {" "}
              <i className="fa fa-angle-left" /> Back
            </button>
            {!profileData.isUserVerified && (
              <button
                type="submit"
                disabled={profileData.isUserVerified}
                // title="back-button"
                className="back-button mt-3 mb-4"
                onClick={() => {
                  setIsCompany(!isCompany);
                }}
              >
                {" "}
                Register as {isCompany ? "User" : "Company"}
              </button>
            )}
          </div>

          <h3>Complete your KYC</h3>

          {isCompany ? (
            <RegisterAsCompany
              inputProfileData={profileData}
              inputBankList={bankList}
            ></RegisterAsCompany>
          ) : (
            profileData && (
              <form id="investorKycForm" onSubmit={handleSubmit(onSubmit)}>
                <div className={`form-group `}>
                  <label htmlFor="firstName">
                    Gender {<span style={{ color: "red" }}>*</span>}
                  </label>
                  <div className="input-group mb-3">
                    <Controller
                      name="gender"
                      control={control}
                      errors={errors}
                      rules={{ required: true }}
                      render={({ field: { onChange, value, ref } }) => (
                        <Select
                          placeholder="Select Gender"
                          value={getValues("gender")}
                          disabled={
                            profileData.gender && profileData.isUserVerified
                          }
                          onChange={genderChange}
                          size="large"
                          className={`${errors.gender ? "is-invalid" : ""}`}
                          options={genderOptions}
                          style={{ width: "100%" }}
                        />
                      )}
                    />

                    <div className="invalid-feedback">Gender is required</div>
                  </div>
                  <label htmlFor="isPoliticallyExposed">
                    Politically Exposed{" "}
                  </label>
                  <div className="input-group mb-3">
                    <Controller
                      name="isPoliticallyExposed"
                      control={control}
                      errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        <Select
                          placeholder="Select Option"
                          value={getValues("isPoliticallyExposed")}
                          disabled={
                            profileData.isPoliticallyExposed &&
                            profileData.isUserVerified
                          }
                          onChange={isPoliticallyExposedChange}
                          size="large"
                          className={`${
                            errors.isPoliticallyExposed ? "is-invalid" : ""
                          }`}
                          options={isPoliticallyExposedOptions}
                          style={{ width: "100%" }}
                        />
                      )}
                    />

                    <div className="invalid-feedback">Gender is required</div>
                  </div>
                  <label htmlFor="pan">
                    PAN Number {<span style={{ color: "red" }}>*</span>}
                  </label>
                  <div className="input-group pb-3">
                    <input
                      disabled={isPanVerified}
                      id="pan"
                      type="text"
                      maxlength={10}
                      className={`form-control ${
                        errors.pan ? "is-invalid" : ""
                      }`}
                      {...register("pan", {
                        minLength: {
                          value: 10,
                          message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
                        },
                        maxLength: {
                          value: 10,
                          message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
                        },
                      })}
                    />

                    <div className="input-group-append">
                      {isPanVerified ? (
                        <span
                          className="input-group-text  rounded-0 "
                          id="basic-addon2"
                        >
                          <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                        </span>
                      ) : (
                        <button
                          disabled={!getValues("pan") || errors?.pan?.message}
                          class="btn btn-outline-primary rounded-0 rounded-right "
                          type="button"
                          id="button-addon2"
                          onClick={() => {
                            setVerifyPanModalState(true);
                          }}
                        >
                          Verify
                        </button>
                      )}
                    </div>
                    <div className="invalid-feedback">
                      {errors?.pan?.message}
                    </div>
                  </div>
                  <VerifyPanModal
                    setActive={setVerifyPanModalState}
                    active={verifyPanModalState}
                    setPanVerified={setIsPanVerified}
                    pan={getValues("pan")}
                  ></VerifyPanModal>
                  <label htmlFor="aadhar">Aadhaar Number</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      disabled={isAadhaarVerified}
                      id="aadhar"
                      maxlength="12"
                      className={`form-control ${
                        errors.aadhar ? "is-invalid" : ""
                      }`}
                      {...register("aadhar", {
                        pattern: {
                          value: /^[0-9]*$/i,
                          message: "should be a number",
                        },
                        minLength: {
                          value: 12,
                          message: "enter a valid aadhar number", // JS only: <p>error message</p> TS only support string
                        },
                      })}
                    />{" "}
                    <div className="input-group-append">
                      {isAadhaarVerified ? (
                        <span
                          className="input-group-text  rounded-0 "
                          id="basic-addon2"
                        >
                          <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                        </span>
                      ) : (
                        <button
                          disabled={
                            !getValues("aadhar") || errors?.aadhar?.message
                          }
                          class="btn btn-outline-primary rounded-0 rounded-right "
                          type="button"
                          id="button-addon2"
                          onClick={() => {
                            setVerifyAadhaarModalState(true);
                          }}
                        >
                          Verify
                        </button>
                      )}
                    </div>
                    <div className="invalid-feedback">
                      {errors?.aadhar?.message}
                    </div>
                  </div>
                  <VerifyAadharModal
                    setActive={setVerifyAadhaarModalState}
                    active={verifyAadhaarModalState}
                    setPanVerified={setIsAadhaarVerified}
                    aadhar={getValues("aadhar")}
                  ></VerifyAadharModal>
                  <label htmlFor="address">Current Address</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      disabled={
                        profileData.address && profileData.isUserVerified
                      }
                      className={`form-control ${
                        errors.address ? "is-invalid" : ""
                      }`}
                      id="address"
                      placeholder=""
                      {...register("address")}
                    />
                    <div className="invalid-feedback">Address is required</div>
                  </div>
                  <label htmlFor="occupation">Occupation</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="occupation"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={`${errors.occupation ? "is-invalid" : ""}`}
                          onChange={occupationChange}
                          value={getValues("occupation")}
                          disabled={
                            profileData.occupation &&
                            !AllowedProfileEditStatus.includes(
                              profileData.status
                            )
                          }
                          size="large"
                          style={{ width: "100%" }}
                        >
                          {occupationOptions.map((item) => (
                            <Option
                              key={item.occupationId}
                              value={item.occupationId}
                            >
                              {item.occupation}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />
                    <div className="invalid-feedback">
                      {" "}
                      {errors?.occupation?.message}
                    </div>
                  </div>
                  <label htmlFor="nameOfOrganization">Company Name</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.nameOfOrganization ? "is-invalid" : ""
                      }`}
                      id="nameOfOrganization"
                      disabled={
                        profileData.nameOfOrganization &&
                        profileData.isUserVerified
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("nameOfOrganization")}
                    />
                    <div className="invalid-feedback">
                      Employer Name is required
                    </div>
                  </div>
                  <label htmlFor="industryType">Industry Type</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.industryType ? "is-invalid" : ""
                      }`}
                      id="industryType"
                      disabled={
                        profileData.industryType && profileData.isUserVerified
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("industryType")}
                    />
                    <div className="invalid-feedback">
                      Industry Type is required
                    </div>
                  </div>
                  <label htmlFor="jobTitle">Job Title</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.jobTitle ? "is-invalid" : ""
                      }`}
                      id="jobTitle"
                      disabled={
                        profileData.jobTitle && profileData.isUserVerified
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("jobTitle")}
                    />
                    <div className="invalid-feedback">
                      Job Title is required
                    </div>
                  </div>
                  <label htmlFor="jobTitle">Nature of Duties</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.natureOfDuties ? "is-invalid" : ""
                      }`}
                      id="natureOfDuties"
                      disabled={
                        profileData.natureOfDuties && profileData.isUserVerified
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("natureOfDuties")}
                    />
                    <div className="invalid-feedback">
                      Nature Of Duties is required
                    </div>
                  </div>
                  <label htmlFor="occupation">Maritial Status</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="maritalStatus"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={`${
                            errors.maritalStatus ? "is-invalid" : ""
                          }`}
                          onChange={maritalStatusChange}
                          value={getValues("maritalStatus")}
                          disabled={
                            profileData.maritalStatus &&
                            !AllowedProfileEditStatus.includes(
                              profileData.status
                            )
                          }
                          size="large"
                          style={{ width: "100%" }}
                        >
                          {maritialStatusOptions.map((item) => (
                            <Option
                              key={item.maritalStatusId}
                              value={item.maritalStatusId}
                            >
                              {item.maritalStatus}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />

                    <div className="invalid-feedback">
                      {" "}
                      {errors?.maritalStatus?.message}
                    </div>
                  </div>
                  <label htmlFor="relativeName">
                    Father's / Mother’s / Spouse Name
                  </label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.relativeName ? "is-invalid" : ""
                      }`}
                      id="relativeName"
                      disabled={
                        profileData.relativeName && profileData.isUserVerified
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("relativeName")}
                    />
                    <div className="invalid-feedback">
                      Relative Name is required
                    </div>
                  </div>
                  <label htmlFor="nationality">Nationality</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="nationality"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={` ${
                            errors.nationality ? "is-invalid" : ""
                          }`}
                          placeholder="Select Option"
                          value={getValues("nationality")}
                          disabled={
                            profileData.nationality &&
                            profileData.isUserVerified
                          }
                          onChange={nationalityChange}
                          size="large"
                          style={{ width: "100%" }}
                        >
                          <Option key="INDIAN" value="INDIAN">
                            Indian
                          </Option>
                          <Option key="NRI" value="NRI">
                            NRI
                          </Option>
                        </Select>
                      )}
                    />
                    <div className="invalid-feedback">Country is required</div>
                  </div>
                  <div className="grid-form">
                    <div>
                      <label htmlFor="city">City</label>
                      <div className="input-group pb-3">
                        <input
                          disabled={
                            profileData.city && profileData.isUserVerified
                          }
                          type="text"
                          className={`form-control ${
                            errors.city ? "is-invalid" : ""
                          }`}
                          id="city"
                          placeholder=""
                          {...register("city", {
                            pattern: {
                              value:
                                /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/i,
                              message: "should not be a number",
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          {" "}
                          {errors?.city?.message}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="countryId">Country</label>
                      <div className="input-group pb-3">
                        <Controller
                          name="countryId"
                          control={control}
                          errors={errors}
                          render={(props) => (
                            <Select
                              className={` ${
                                errors.countryId ? "is-invalid" : ""
                              }`}
                              placeholder="Select Country"
                              value={getValues("countryId")}
                              disabled={
                                profileData.countryId &&
                                profileData.isUserVerified
                              }
                              onChange={countryChange}
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {countries.map((item) => (
                                <Option
                                  key={item.countryId}
                                  value={item.countryId}
                                >
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                        />
                        <div className="invalid-feedback">
                          Country is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid-form">
                    <div>
                      <label htmlFor="stateId">State</label>
                      <div className="input-group pb-3">
                        <Controller
                          name="stateId"
                          control={control}
                          errors={errors}
                          render={(props) => (
                            <Select
                              className={` ${
                                errors.stateId ? "is-invalid" : ""
                              }`}
                              placeholder="Select State"
                              onChange={stateChange}
                              value={getValues("stateId")}
                              disabled={
                                profileData.stateId &&
                                profileData.isUserVerified
                              }
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {stateList.map((item) => (
                                <Option key={item.stateId} value={item.stateId}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                        />
                        <div className="invalid-feedback">
                          State is required
                        </div>
                      </div>
                    </div>

                    <div>
                      <label htmlFor="pincode">Pincode</label>
                      <div className="input-group pb-3">
                        <input
                          type="text"
                          maxlength="6"
                          disabled={
                            profileData.pinCode && profileData.isUserVerified
                          }
                          className={`form-control ${
                            errors.pinCode ? "is-invalid" : ""
                          }`}
                          id="pinCode"
                          placeholder=""
                          {...register("pinCode", {
                            pattern: {
                              value: /^[0-9]*$/i,
                              message: "should be a number",
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors?.pinCode?.message}
                        </div>
                      </div>
                    </div>
                  </div>
                  <label htmlFor="bankAccountNumber">Bank Account Number</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.bankAccountNumber ? "is-invalid" : ""
                      }`}
                      id="bankAccountNumber"
                      disabled={
                        profileData.bankAccountNumber &&
                        profileData.isUserVerified
                      }
                      placeholder=""
                      {...register("bankAccountNumber", {
                        pattern: {
                          value: /^[0-9]*$/i,
                          message: "should be a number",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.bankAccountNumber?.message}
                    </div>
                  </div>
                  <label htmlFor="bankBranchName">Bank Branch Name</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.bankBranchName ? "is-invalid" : ""
                      }`}
                      id="bankBranchName"
                      disabled={
                        profileData.bankBranchName && profileData.isUserVerified
                      }
                      placeholder=""
                      {...register("bankBranchName", {})}
                    />
                    <div className="invalid-feedback">
                      {errors?.bankBranchName?.message}
                    </div>
                  </div>
                  <label htmlFor="bankName">Bank Name</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="bankId"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={`${errors.bankId ? "is-invalid" : ""}`}
                          onChange={bankNameChange}
                          value={getValues("bankId")}
                          disabled={
                            profileData.bankId && profileData.isUserVerified
                          }
                          size="large"
                          style={{ width: "100%" }}
                        >
                          {bankList.map((item) => (
                            <Option key={item.bankId} value={item.bankId}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />
                    <div className="invalid-feedback">
                      Bank Name is required
                    </div>
                  </div>
                  <label htmlFor="accountType">Account Type</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="accountType"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={`${
                            errors.accountType ? "is-invalid" : ""
                          }`}
                          value={getValues("accountType")}
                          disabled={
                            profileData.accountType &&
                            profileData.isUserVerified
                          }
                          onChange={accountTypeChange}
                          size="large"
                          style={{ width: "100%" }}
                        >
                          {getBankAccountType()}
                        </Select>
                      )}
                    />

                    <div className="invalid-feedback">
                      Account Type is required
                    </div>
                  </div>
                  <label htmlFor="ifscCode">IFSC Code</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.IFSCCode ? "is-invalid" : ""
                      }`}
                      id="IFSCCode"
                      disabled={
                        profileData.IFSCCode && profileData.isUserVerified
                      }
                      aria-describedby="IFSCCode"
                      placeholder=""
                      {...register("IFSCCode")}
                    />
                  </div>{" "}
                  <label htmlFor="UPICode">UPI ID</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.UPICode ? "is-invalid" : ""
                      }`}
                      id="UPICode"
                      disabled={
                        profileData.UPICode &&
                        !AllowedProfileEditStatus.includes(profileData.status)
                      }
                      aria-describedby="emailHelp"
                      placeholder=""
                      {...register("UPICode")}
                    />
                    <div className="invalid-feedback">UPI is required</div>
                  </div>
                  <label htmlFor="EIANumber">EIA Number</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.EIANumber ? "is-invalid" : ""
                      }`}
                      id="EIANumber"
                      disabled={
                        profileData.EIANumber &&
                        !AllowedProfileEditStatus.includes(profileData.status)
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("EIANumber")}
                    />
                    <div className="invalid-feedback">
                      EIA Number is required
                    </div>
                  </div>
                  <label htmlFor="annualIncome">Annual Income</label>
                  <div className="input-group pb-3">
                    <input
                      type="number"
                      className={`form-control ${
                        errors.annualIncome ? "is-invalid" : ""
                      }`}
                      id="annualIncome"
                      disabled={
                        profileData.annualIncome &&
                        !AllowedProfileEditStatus.includes(profileData.status)
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("annualIncome", {
                        pattern: {
                          value: /^\d+$/,
                          message: "Please enter a valid income",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors.annualIncome && (
                        <span>{errors?.annualIncome?.message}</span>
                      )}
                    </div>
                  </div>
                  <label htmlFor="sourceOfFund">Source of Fund</label>
                  <div className="input-group pb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.sourceOfFund ? "is-invalid" : ""
                      }`}
                      id="sourceOfFund"
                      disabled={
                        profileData.sourceOfFund &&
                        !AllowedProfileEditStatus.includes(profileData.status)
                      }
                      // aria-describedby="emailHelp"
                      placeholder=""
                      {...register("sourceOfFund")}
                    />
                    <div className="invalid-feedback">
                      {errors.sourceOfFund && (
                        <span>{errors?.sourceOfFund?.message}</span>
                      )}
                    </div>
                  </div>
                  <label htmlFor="education">Education</label>
                  <div className="input-group pb-3">
                    <Controller
                      name="education"
                      control={control}
                      errors={errors}
                      render={(props) => (
                        <Select
                          className={`${errors.education ? "is-invalid" : ""}`}
                          value={getValues("education")}
                          disabled={
                            profileData.education &&
                            !AllowedProfileEditStatus.includes(
                              profileData.status
                            )
                          }
                          onChange={educationChange}
                          size="large"
                          style={{ width: "100%" }}
                        >
                          {getEducationType()}
                        </Select>
                      )}
                    />

                    <div className="invalid-feedback">
                      Account Type is required
                    </div>
                  </div>
                  {/* <label htmlFor="isSmoker">Do you Smoke? </label>
                  <div className="input-group mb-3">
                    <Controller
                      name="isSmoker"
                      control={control}
                      errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        <Select
                          placeholder="Select Option"
                          value={getValues("isSmoker")}
                          disabled={
                            profileData.isSmoker && profileData.isUserVerified
                          }
                          onChange={isSmokerChange}
                          size="large"
                          className={`${errors.isSmoker ? "is-invalid" : ""}`}
                          options={isSmokerOptions}
                          style={{ width: "100%" }}
                        />
                      )}
                    />
                  </div> */}
                  <h3 className="pt-2">Nominee Details</h3>
                  <Divider className="mt-0" />
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label htmlFor="name">Nominee Name</label>
                      <div className="md-form">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.nomineeName ? "is-invalid" : ""
                          }`}
                          id="name"
                          name="name"
                          placeholder="Enter Nominee Name"
                          {...register("nomineeName", {
                            pattern: {
                              value: /^[a-z ,.'-]+$/i,
                              message: "Enter valid Name",
                            },
                          })}
                          // {...register("nomineeName", {})}
                        />
                        {errors?.nomineeName && (
                          <div className="invalid-feedback">
                            {errors?.nomineeName?.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label htmlFor="policyTerm">Nominee Email</label>
                      <input
                        type="text"
                        className={`form-control${
                          errors.nomineeEmail ? " is-invalid" : ""
                        }`}
                        id="nomineeEmail"
                        name="nomineeEmail"
                        // pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        title="Enter Correct Email"
                        placeholder="Enter Nominee Email"
                        // onChange={onNomineeUpdate}
                        {...register("nomineeEmail", {
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {errors?.nomineeEmail && (
                        <div className="invalid-feedback">
                          {errors?.nomineeEmail?.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label htmlFor="lastPremiumPaidDate">
                        Nominee Contact
                      </label>
                      <div className="md-form">
                        <input
                          type="text"
                          id="nomineeContact"
                          name="nomineeContact"
                          pattern="\d{10,10}"
                          placeholder="Enter Nominee Contact"
                          className={`form-control${
                            errors.nomineeContact ? " is-invalid" : ""
                          }`}
                          {...register("nomineeContact", {
                            pattern: {
                              value:
                                /^(\+?\d{1,4}[\s-])?(?!0+\s+,?$)\d{10}\s*,?$/i,
                              message: "mobile number must be 10 digits",
                            },
                          })}
                        />
                        {errors?.nomineeContact && (
                          <div className="invalid-feedback">
                            {errors?.nomineeContact?.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label htmlFor="dob">Nominee DOB</label>
                      {/* {console.log("ffff"+profileData.nomineeDob)} */}
                      <Controller
                        name="nomineeDob"
                        control={control}
                        errors={errors}
                        render={(props) => {
                          // if(Object.keys(profileData).length){
                          return (
                            <DatePicker
                              inputReadOnly
                              id="nomineeDob"
                              name="nomineeDob"
                              // defaultValue={() => {
                              //   if (Object.keys(profileData).length) {
                              //     console.log("hello", profileData.nominees[0]);
                              //     return dayjs(
                              //       profileData.nominees[0].dob,
                              //       "YYYY/MM/DD"
                              //     );
                              //   }
                              // }}
                              // defaultValue={
                              //   profileData.nominees &&
                              //   profileData.nominees.length === 1
                              //     ?
                              //   dayjs(
                              //     profileData.nominees[0]["dob"] || "2001/06/24",
                              //     "YYYY/MM/DD"
                              //   )
                              //   :
                              //    dayjs("2001/06/24")
                              // }
                              disabledDate={(current) => {
                                const startDate = moment().subtract(
                                  18,
                                  "years"
                                );
                                return (
                                  startDate && current.valueOf() > startDate
                                );
                              }}
                              defaultPickerValue={dayjs(
                                get18YearBackDate(),
                                "YYYY-MM-DD"
                              )}
                              className={`form-control`}
                              onChange={(_, data) => {
                                setValue("nomineeDob", new Date(data));
                              }}
                              {...props}
                            />
                          );
                          // }
                          //  else{
                          //   return null
                          //  }
                        }}
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label htmlFor="name">Nominee Relationship</label>
                      <div className="md-form">
                        <Controller
                          name="nomineeRelationship"
                          control={control}
                          errors={errors}
                          render={({ field: { onChange, value, ref } }) => (
                            <Select
                              placeholder="Select Option"
                              value={getValues("nomineeRelationship")}
                              disabled={
                                profileData.nomineeRelationship &&
                                profileData.isUserVerified
                              }
                              onChange={relationshipChange}
                              size="large"
                              className={`${
                                errors.relationship ? "is-invalid" : ""
                              }`}
                              options={relationshipOptions}
                              style={{ width: "100%" }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <h3 className="pt-2">Document Upload</h3>
                <p style={{ color: "grey" }}>
                  Upload only jpg, png, pdf files. Max size 5 MB.
                </p>
                <Divider className="mt-0" />
                {!profileData.PANDocument && (
                  <div className="mb-3 mt-2">
                    <label htmlFor="formFile" className="form-label">
                      Upload PAN{" "}
                      <>{documentWidget(documentHill.panDoc, iretryFunction)}</>
                    </label>
                    <input
                      className={`form-control ${
                        errors.pan ? "is-invalid" : ""
                      }`}
                      type="file"
                      id="pan"
                      accept={documentAccpetedTypes}
                      onChange={(event) => {
                        handleDocumentNew(event, documentHill.panDoc.key);
                      }}
                    />{" "}
                  </div>
                )}
                {!profileData.AADHARDocument && (
                  <div className="mb-3 mt-2">
                    <label htmlFor="formFile" className="form-label">
                      Upload Aadhar{" "}
                      <>
                        {documentWidget(documentHill.aadharDoc, iretryFunction)}
                      </>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="annualStatement"
                      accept={documentAccpetedTypes}
                      onChange={(event) => {
                        handleDocumentNew(event, documentHill.aadharDoc.key);
                      }}
                    />{" "}
                  </div>
                )}

                {!profileData.cancelledCheck && (
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Cancelled Cheque{" "}
                      <>
                        {documentWidget(
                          documentHill.cancelledChecqDoc,
                          iretryFunction
                        )}
                      </>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="annualStatement"
                      accept={documentAccpetedTypes}
                      onChange={(event) => {
                        handleDocumentNew(
                          event,
                          documentHill.cancelledChecqDoc.key
                        );
                      }}
                    />{" "}
                  </div>
                )}
                {!profileData.ITRCopy && (
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Latest ITR Copy{" "}
                      <>{documentWidget(documentHill.ITRDoc, iretryFunction)}</>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="annualStatement"
                      accept={documentAccpetedTypes}
                      onChange={(event) => {
                        handleDocumentNew(event, documentHill.ITRDoc.key);
                      }}
                    />{" "}
                  </div>
                )}
                {!profileData.bankStatement && (
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Last 3 Months Bank Statement{" "}
                      <>
                        {documentWidget(
                          documentHill.bankStatementDoc,
                          iretryFunction
                        )}
                      </>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      accept={documentAccpetedTypes}
                      id="bankStatementDoc"
                      onChange={(event) => {
                        handleDocumentNew(
                          event,
                          documentHill.bankStatementDoc.key
                        );
                      }}
                    />{" "}
                  </div>
                )}
                {!profileData.photo && (
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Standard Photograph{" "}
                      <>
                        {documentWidget(documentHill.photoDoc, iretryFunction)}
                      </>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      accept={documentAccpetedTypes}
                      id="photoDoc"
                      onChange={(event) => {
                        handleDocumentNew(event, documentHill.photoDoc.key);
                      }}
                    />{" "}
                  </div>
                )}

                {!profileData.passportDocument && (
                  <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">
                      Upload Passport{" "}
                      <>
                        {documentWidget(
                          documentHill.passportDoc,
                          iretryFunction
                        )}
                      </>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      accept={documentAccpetedTypes}
                      id="passportDoc"
                      onChange={(event) => {
                        handleDocumentNew(event, documentHill.passportDoc.key);
                      }}
                    />{" "}
                  </div>
                )}
                <button
                  form="investorKycForm"
                  className="normal-button-investor mb-5 px-3 py-2"
                >
                  {loading ? "Loading" : "Submit"}
                </button>
              </form>
            )
          )}
        </div>
      </div>
      {!isMobile && (
        <div className="rightDivInvestorKYC">
          <div className="common-width-inv">
            <img
              style={{ width: "100%", paddingLeft: "20px" }}
              src={chooseInvestor}
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
}
